<ng-template #editBuletinModal let-modal="close('Cross click')">
  <div class="modal-header d-flex justify-content-between flex-wrap flex-row-reverse border-0">
    <div class="d-inline-flex align-items-center justify-content-start order-md-1 custom-modal-btn mt-0">
      <button
        class="btn btn-sm btn-dark"
        (click)="(modal); notifyCloseModal()"
        autofocus="false"
      >
        Închide
      </button>

      <button
        *ngIf="!cantaririDetails.readonly"
        class="btn btn-sm btn-success"
        [ngClass]="{disabled: count === 0}"
        (click)="onSubmitted()"
      >
        <span>
          Salvează buletin de control
        </span>
      </button>
    </div>

    <div class="d-inline-flex align-items-center justify-content-center flex-wrap flex-column flex-md-row col-9 col-sm-auto order-md-2 ml-xl-5 pl-xl-5 mr-xl-auto modal-title text-center">
      <h3 class="m-0 mr-2">Buletin de control la {{ this.cantaririDetails.type }} luni</h3>
      <h4 class="m-0">din {{ cantaririDetails.date }}</h4>
    </div>

    <div class="d-inline-flex align-items-center justify-content-end flex-wrap order-md-3">
      <h5 class="m-0 mr-2">Operator control</h5>
      <ng-select
        [items]="operatori"
        bindLabel="full_name"
        bindValue="id"
        [(ngModel)]="cantaririDetails.userid"
        placeholder="Alege operatorul"
        class="w16"
        [ngClass]="{ 'disabled': cantaririDetails.readonly }"
        [dropdownPosition]="'bottom'"
      >
      </ng-select>
    </div>
  </div>

  <ngb-alert
    type="danger"
    class="text-center search-error"
    *ngIf="count === 0"
    [dismissible]="false"
  >
    Nu a fost găsită nici o cântărire.
  </ngb-alert>

  <div
    *ngIf="count > 0"
    class="modal-body p-0"
  >
    <div class="container-fluid px-xl-3">
      <form [formGroup]="cantaririForm">
        <div>
          <table
            class="table-sm table-bordered dt-responsive table-hover w-100 mb-3"
            formArrayName="cantariri"
          >
            <thead class="sticky">
              <tr>
                <th>
                  Nr. crt
                </th>
                <th>
                  Animal cântărit
                </th>
                <th>
                  Greutate la naștere
                </th>
                <th>
                  Vârstă la cântărire
                </th>
                <th>
                  Greutate la data cântăririi
                </th>
                <th>
                  GVR
                </th>
                <th>
                  SMZ (G/ZI)
                </th>
                <th>
                  Destinație
                </th>
                <th>
                  Observații
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                [formGroupName]="i"
                *ngFor="
                  let item of cantaririForm['controls'].cantariri['controls'];
                  let i = index
                "
              >
                <td class="text-center">{{i + 1}}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <ng-container [ngSwitch]="item.value.sex">
                      <span *ngSwitchCase="1" class="box-mascul">M</span>
                      <span *ngSwitchCase="2" class="box-femela">F</span>
                    </ng-container>

                    <span
                      [ngClass]="{
                        'color-mascul': item.value.sex === 1,
                        'color-femela': item.value.sex === 2
                      }"
                      class="mr-2"
                    >{{ item.value.numarmatricol }}</span>

                    <span>{{ item.value.rasa_text }}</span>

                    <a
                      *ngIf="item.value.animalid"
                      [routerLink]="'/dashboard/animal/' + item.value.animalid"
                      target="_blank"
                      class="ml-2 fs-3"
                      ><i class="mdi mdi-open-in-new mr-1"></i
                    ></a>
                  </div>
                </td>

                <td class="min-w5 text-center">
                  {{ item.value.greutate_nastere }}
                </td>

                <td class="text-center">
                  {{ item.value.varsta_cantarire }}
                </td>

                <td>
                  <input
                    type="number"
                    class="form-control m-auto"
                    formControlName="weight"
                    placeholder="Greutate"
                    [readonly]="cantaririDetails.readonly || item.value.read_only"
                    (change)="weightChanged(i)"
                  />
                </td>

                <td class="text-center">
                  {{ item.value.gvr }}
                </td>

                <td class="text-center">
                  {{ item.value.smz }}
                </td>

                <td>
                  <ng-select
                    bindLabel="destinationid"
                    bindValue="destinationid"
                    formControlName="destinationid"
                    class="m-auto"
                    [ngClass]="{ 'disabled': cantaririDetails.readonly }"
                  >
                    <ng-option [value]="1">Reproducție</ng-option>
                    <ng-option [value]="2">Carne</ng-option>
                  </ng-select>
                </td>

                <td>
                  <input
                    type="text"
                    placeholder="Observații"
                    class="form-control min-w10"
                    name="notes"
                    formControlName="notes"
                    [readonly]="cantaririDetails.readonly"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>

      <div
        *ngIf="isAdmin || isOperator"
        class="row"
      >
        <div class="col-12 pl-md-4">
          <app-upload-fisier
            *ngIf="!cantaririDetails.file_id"
            (ApiResponse)="uploadServerResponse($event)">
          </app-upload-fisier>

          <div *ngIf="cantaririDetails.file_id" class="form-group mb-3">
            <span
              class="file-button"
              (click)="downloadFile($event)"
            >
              {{ cantaririDetails.file_name }}
            </span>

            <button
              *ngIf="isSuperAdmin || !cantaririDetails.readonly"
              type="button"
              class="btn btn-lg p-0 ml-2 mdi mdi-delete text-danger"
              ngbTooltip="Șterge fișier"
              placement="right"
              (click)="deleteFile()"
            >
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
